import PathType from "../../../consts/pathmodule/PathType";
import { IJobResumeDto } from "./IJobResumeDto";

export default class PathMetaApiReadJobResumeDto extends IJobResumeDto {
	RowCount: number;
	constructor(
		rowCount: number) {
		super(PathType.MetaApi);
		this.RowCount = rowCount;
	}
}